import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 22\" id=\"bell\"><path fill-rule=\"evenodd\" d=\"M14.182 18.273a2.728 2.728 0 0 1-5.455 0H1a2.73 2.73 0 0 0 2.727-2.727v-5A7.72 7.72 0 0 1 8.761 3.31a2.725 2.725 0 0 1 5.385 0c2.938 1.094 5.036 3.916 5.036 7.236v5a2.726 2.726 0 0 0 2.727 2.727z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol